import { MenuItemWithTranslations } from '../types/menu';
import { trackUserInteraction } from '../utils/tracking';
import { logAnalyticsEvent } from '../config/firebase';
import { ref, push, serverTimestamp } from 'firebase/database';
import { database } from '../config/firebase';

interface MenuItemInteractionData {
  item: MenuItemWithTranslations;
  action: 'create' | 'edit' | 'delete' | 'view_details';
}

export const trackMenuItemInteraction = async ({ item, action }: MenuItemInteractionData) => {
  if (!item?.id) return;

  try {
    // Try Firebase Analytics first
    logAnalyticsEvent('menu_item_interaction', {
      item_id: item.id,
      item_name: item.translations?.fr?.name || 'Unknown',
      action,
      category: item.category || 'Uncategorized',
      price: item.price || 0
    });
  } catch (error) {
    console.warn('Menu item interaction analytics failed (non-fatal):', error);
  }

  try {
    // Fallback to database tracking
    const analyticsRef = ref(database, 'analytics/interactions');
    await push(analyticsRef, {
      type: 'menu_item',
      action,
      itemId: item.id,
      itemName: item.translations?.fr?.name || 'Unknown',
      category: item.category || 'Uncategorized',
      price: item.price || 0,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.warn('Menu item interaction DB tracking failed (non-fatal):', error);
  }
};

export const trackCategoryView = (category: string) => {
  if (!category) {
    console.warn('Invalid category data for tracking');
    return;
  }

  logAnalyticsEvent('category_view', {
    category_name: category,
    timestamp: new Date().toISOString()
  });

  void trackUserInteraction('view', 'category', category);
};

export const trackImageUpload = async (
  success: boolean, 
  size: number, 
  type: string, 
  error?: string
) => {
  try {
    const analyticsRef = ref(database, 'analytics/interactions');
    await push(analyticsRef, {
      type: 'image_upload',
      success,
      size,
      fileType: type,
      error: error || null,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error('Error tracking image upload:', error);
  }
};

export const trackTranslation = (
  sourceLang: string,
  targetLang: string,
  success: boolean,
  error?: string
) => {
  logAnalyticsEvent('translation_event', {
    source_language: sourceLang,
    target_language: targetLang,
    success,
    error: error || null,
    timestamp: new Date().toISOString()
  });
};
  